import Box from "@mui/material/Box";
import Sidebar from "./components/Layout/Sidebar";
import GeneralContainer from "./components/Layout/GeneralContainer";
import SlideChat from "./components/Layout/SlideChat";
import { FormProvider, useForm } from "react-hook-form";
import { useCallback, useEffect, useRef, useState } from "react";
import { useDispatchApp, useSelectorApp } from "../../lib/redux";
import { useMediaQuery, useTheme } from "@mui/material";
import { getKeyDatabase } from "../../services/public";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import {
  startGetAdsCampaign,
  startGetBrandInformation,
  startGetDraftCampaign,
  startGetRecommendedSettingsPlatform,
  startUpdateAdsCampaignsInformationFromPlatforms,
  startUpdateCampaignEntityStatus,
  checkAndAddPublishingCampaign,
  startGetCurrencyTax,
  startSaveAdsCampaignDraft,
  startListenerAdsCampaignActionStatus,
  stopListenerAdsCampaignActionStatus,
  checkAndShowNpsForm,
  checkAndSaveUserOnboardingChecklist,
} from "../../actions/adsCampaigns";
import { startTrackHomeFeatureUsage } from "../../actions/homeFeatureActivity";
import { HOME_FEATURE_ID } from "../../data/homeFeatures";
import { startGetCampaignChat } from "../../actions/chat";
import {
  normalizeCampaignApprovalState,
  startBumpCampaignApprovalDraft,
  startEnableCampaignApproval,
  startListenerCampaignApproval,
  stopListenerCampaignApproval,
} from "../../actions/campaignApproval";
import { deriveApprovalStatusFromReviewers } from "../../components/ContentApproval/approvalReviewersUtils";
import {
  ADS_CAMPAIGN_ENTITIES,
  ADS_CAMPAIGN_STATUS_ACTIVE,
  ADS_CAMPAIGN_STATUS_DRAFT,
  ADS_CAMPAIGN_STATUS_FINISHED,
  ALERT_ICON_TYPE_SUCCESS,
  ALERT_ICON_TYPE_INFO,
  ALERTS_ASYNC_STATUS,
  ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD,
  NPS_RATING_ACTION_CREATE,
  NPS_RATING_ACTION_ACTIVE_7_DAYS,
  NPS_RATING_ACTION_ACTIVE_30_DAYS,
  MIN_WIDTH_SCREEN_TO_SHOW_CHAT,
  CHECKLIST_CREATE_CAMPAIGN,
  ROUTE_CAMPAIGNS,
} from "../../utils/constants";
import { useCreditActionCosts } from "../../hooks/useCreditActionCosts";
import { useRebrandBanner } from "../../hooks/useRebrandBanner";
import {
  getCurrencyAdAccountPlatform,
  getIsBlockedActions,
  getRoleCapability,
} from "../../actions/getters";
import Loader from "../../components/Loaders/Loader";
import {
  ADS_CAMPAIGN_HAS_BEEN_SAVE,
  ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN,
  ALERT_FILL_BRAND_SETUP_TITLE,
  ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION,
  BUTTON_COMPLETE_INFORMATION,
  CAMPAIGN_GENERATED_ERROR,
  CAMPAIGN_GENERATED_SUCCESS,
  CAMPAIGN_IS_GENERATING,
  GENERATING_CAMPAIGN,
  LOADING_INFORMATION,
  READY,
} from "../../i18n/keysTranslations";
import { useTranslationApp } from "../../lib/i18next";
import { getCampaignUpdatedByStatus } from "../../services/adsCampaigns";
import { ConfirmAlert, SimpleAlert } from "../../components/Alerts/Alerts";
import ApprovalEnableSuccessDialog from "../../components/ContentApproval/ApprovalEnableSuccessDialog";
import ModalErrorsCampaigns from "../AdsCampaign/components/ModalErrorsCampaigns";
import { zodResolver } from "@hookform/resolvers/zod";
import { getCampaignSchema } from "./utils/schemas/campaignSchema";
import { useUploadAsyncContentInCampaign } from "./hooks/useUploadAsyncContentInCampaign";
import i18next from "i18next";
import _ from "lodash";
import { Helmet } from "react-helmet";
import {
  consumePendingIntegrationFormSyncForCampaign,
  updateNotification,
} from "../../actions/alerts";
import FloatingValidationErrorsPanel from "./components/Common/FloatingValidationErrorsPanel";
import {
  getCreativeOptimizationSlotKey,
  getFormPathForCreativeSlot,
} from "../../utils/creativeOptimizationContext";
import SlideMenu from "../../components/Menus/SlideMenu";
import { consumeJustImportedCampaign } from "../../utils/importedCampaignAlert";
import CampaignApprovalPanel from "./components/CampaignApproval/CampaignApprovalPanel";
import { ApprovalCommentFieldHintProvider } from "./components/CampaignApproval/approvalCommentFieldHintContext";

const EMPTY_PLATFORMS = [];

const NewAdsCampaign = () => {
  const { totalTopOffsetPx } = useRebrandBanner();
  const [adsCampaignActionStatusListener, setAdsCampaignActionStatusListener] =
    useState(null);
  const [campaignActionStatus, setCampaignActionStatus] = useState(null);
  const [currencyTaxes, setCurrencyTaxes] = useState(null);
  const [schema, setSchema] = useState(null);
  const [isForcedSetupPage, setIsForcedSetupPage] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isChatVisible, setIsChatVisible] = useState(false);
  const [sectionSelected, setSectionSelected] = useState({
    platform: undefined,
    assetsGroupID: undefined,
    adGroupID: undefined,
    adID: undefined,
  });
  const [isSyncingData, setIsSyncingData] = useState(false);
  const [platformGenerating, setPlatformGenerating] = useState(null);
  const [lastInformationToGenerate, setLastInformationToGenerate] = useState(
    {}
  );
  const [optimizations, setOptimizations] = useState([]);
  const [creativeOptimizations, setCreativeOptimizations] = useState({});
  const [showErrorGenerating, setShowErrorGenerating] = useState(false);
  const [modalErrorsCampaignsOpen, setModalErrorsCampaignsOpen] =
    useState(false);
  const [dataModalErrorsCampaigns, setDataModalErrorsCampaigns] = useState({});
  const [campaignID, setCampaignID] = useState(null);
  const [brandInformation, setBrandInformation] = useState({});
  const [statistics, setStatistics] = useState({});
  const [isLoadingStatistics, setIsLoadingStatistics] = useState(false);
  const [previewsCached, setPreviewsCached] = useState({});
  const [audiencePreviewsCache, setAudiencePreviewsCache] = useState({});
  const [chatMessages, setChatMessages] = useState({});
  const [shouldOpenChat, setShouldOpenChat] = useState(false);
  const [isPlatformClicked, setIsPlatformClicked] = useState(false);
  const [campaignApproval, setCampaignApproval] = useState(
    normalizeCampaignApprovalState(null)
  );
  const [isEnablingCampaignApproval, setIsEnablingCampaignApproval] =
    useState(false);
  const [campaignApprovalListener, setCampaignApprovalListener] =
    useState(null);
  const [isApprovalCommentsPanelOpen, setIsApprovalCommentsPanelOpen] =
    useState(false);
  const [approvalSuccessDialog, setApprovalSuccessDialog] = useState({
    open: false,
    approvalUrl: "",
    reviewerID: "",
  });

  const clearPreloadedChatMessagesRef = useRef(null);
  const lastInitialLoadCampaignIDRef = useRef(null);
  const previousApprovalStatusRef = useRef(campaignApproval?.status);
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const platform = searchParams.get("platform");

  const methodsDateFilters = useForm({
    defaultValues: {
      datePreset: "",
      dateRange: {
        startDateTime: "",
        endDateTime: "",
      },
    },
  });

  const methods = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      context: "",
      language: "",
      locations: {
        contexts: [],
        locations: [],
      },
      platforms: [],
    },
    shouldUnregister: false,
    mode: "onChange",
    reValidateMode: "onChange",
  });
  const { getValues, setValue, watch, reset } = methods;
  const generatedPlatforms = watch("generatedPlatforms") || {};

  const onUpsertCreativeOptimization = useCallback((entry) => {
    const { title, action, field, formPath } = entry || {};
    if (!title || !action || !field || !formPath) return;
    const slotKey = getCreativeOptimizationSlotKey({
      formPath,
      field,
    });
    setCreativeOptimizations((prev) => ({
      ...prev,
      [slotKey]: { ...entry, slotKey },
    }));
  }, []);

  const onRemoveCreativeOptimization = useCallback((slotKey) => {
    setCreativeOptimizations((prev) => {
      if (!(slotKey in prev)) return prev;
      const next = { ...prev };
      delete next[slotKey];
      return next;
    });
  }, []);

  const dispatch = useDispatchApp();
  const navigate = useNavigate();
  const [params, setSearchParams] = useSearchParams();
  const { t } = useTranslationApp();
  const { ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION } = useCreditActionCosts();
  const muiTheme = useTheme();
  const isLargeScreen = useMediaQuery(
    muiTheme.breakpoints.up(MIN_WIDTH_SCREEN_TO_SHOW_CHAT)
  );
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"));

  const campaignIDParam = params.get("campaignID");
  const platformParam = params.get("platform");
  const assetsGroupIDParam = params.get("assetsGroupID");
  const adGroupIDParam = params.get("adGroupID");
  const adIDParam = params.get("adID");
  const chatIDParam = params.get("chatID");
  const doSyncParam = params.get("doSync");
  const doSync = doSyncParam ? doSyncParam === "true" : true;
  const showDraftParam = params.get("showDraft");
  const showDraft = showDraftParam ? showDraftParam === "true" : false;
  const integrations = useSelectorApp((state) => state?.user?.integrations);
  const { theme } = useSelectorApp((state) => state.ui);
  const pendingIntegrationFormSync = useSelectorApp(
    (state) => state?.alerts?.pendingIntegrationFormSync
  );

  const startSaveAdsCampaignWithApproval = useCallback(
    ({ campaign, campaignID: targetCampaignID, shouldBumpApproval = true }) =>
      async (dispatchInternal) => {
        const isSaved = await dispatchInternal(
          startSaveAdsCampaignDraft({
            campaign,
            campaignID: targetCampaignID,
          })
        );

        if (
          isSaved &&
          shouldBumpApproval &&
          targetCampaignID === campaignID &&
          campaignApproval?.enabled
        ) {
          await dispatchInternal(
            startBumpCampaignApprovalDraft({
              campaignID: targetCampaignID,
            })
          );
        }

        return isSaved;
      },
    [campaignApproval?.enabled, campaignID]
  );

  const onEnableCampaignApproval = async () => {
    if (!campaignID) {
      return false;
    }

    setIsEnablingCampaignApproval(true);
    const response = await dispatch(
      startEnableCampaignApproval({ campaignID })
    );
    setIsEnablingCampaignApproval(false);

    if (response?.ok && response?.url) {
      setApprovalSuccessDialog({
        open: true,
        approvalUrl: response.url,
        reviewerID: response.reviewerID || "",
      });
    }

    return response;
  };

  const onCopyCampaignApprovalLink = () => {
    const approvalUrl = campaignApproval?.url;
    if (!approvalUrl || !navigator?.clipboard?.writeText) {
      return;
    }

    navigator.clipboard.writeText(approvalUrl).catch(() => {});
    SimpleAlert({
      title: t(READY),
      icon: ALERT_ICON_TYPE_SUCCESS,
    });
  };

  const onOpenCampaignApprovalCommentsPanel = () => {
    setIsApprovalCommentsPanelOpen(true);
  };

  useUploadAsyncContentInCampaign({
    campaignID,
    getValues,
    setValue,
    watch,
  });

  const states = watch("states") || {};
  const rawPlatforms = watch("platforms");
  const platforms = rawPlatforms ?? EMPTY_PLATFORMS;
  const platformsDepKey = Array.isArray(rawPlatforms)
    ? rawPlatforms.join("|")
    : "";
  const platformIDs = watch("platformIDs") || [];
  const hasSomePlatformDraft = Object.keys(states || {}).some(
    (key) => states[key] === ADS_CAMPAIGN_STATUS_DRAFT
  );
  const hasSomePlatformCreated = Object.keys(states || {}).some(
    (key) => states[key] !== ADS_CAMPAIGN_STATUS_DRAFT
  );
  const isViewOnboarding =
    !platform ||
    platform === "undefined" ||
    isForcedSetupPage ||
    platforms.length === 0;

  const onGenerateCampaignPlatform = async (platformData) => {
    const formValues = getValues();
    const currentPlatforms = formValues.platforms || [];

    setShowErrorGenerating(false);
    const newPlatforms = [...currentPlatforms, platformData.platform];
    setLastInformationToGenerate(platformData);

    if (isForcedSetupPage) {
      setIsForcedSetupPage(false);
    }

    setPlatformGenerating(platformData.platform);
    // Alert Generate Campaign
    if (!isViewOnboarding) {
      dispatch(
        checkAndAddPublishingCampaign({
          campaignID,
          isCreating: false,
          isGenerating: true,
          status: ALERTS_ASYNC_STATUS.GENERATING,
          message: t(GENERATING_CAMPAIGN),
          progress: 0,
          platformGeneratingData: platformData,
          currentCampaign: getValues(),
          newPlatforms: newPlatforms,
          buttonAction: "addPlatform",
          platform: platformData.platform,
        })
      );

      const campaign = getValues();
      await dispatch(
        startSaveAdsCampaignWithApproval({
          campaign,
          campaignID,
        })
      );
    }
    onChangeSectionSelected({
      platform: undefined,
      assetsGroupID: undefined,
      adGroupID: undefined,
      adID: undefined,
    });
    const response = await dispatch(
      startGetRecommendedSettingsPlatform({
        ...platformData,
        ...formValues,
        platforms: newPlatforms,
        campaignID,
      })
    );
    if (response.ok) {
      setShowErrorGenerating(false);
      const data = response.data;
      reset(data);

      if (isViewOnboarding) {
        onChangeSectionSelected({
          platform: platformData.platform,
          assetsGroupID: undefined,
          adGroupID: undefined,
          adID: undefined,
        });
      }
      // Alert Campaign Generated Correctly
      if (!isViewOnboarding) {
        dispatch(
          updateNotification(campaignID, {
            status: ALERTS_ASYNC_STATUS.SUCCESS,
            message: t(CAMPAIGN_GENERATED_SUCCESS),
            isCreating: false,
          })
        );
      }

      dispatch(checkAndShowNpsForm(NPS_RATING_ACTION_CREATE));
      dispatch(checkAndSaveUserOnboardingChecklist(CHECKLIST_CREATE_CAMPAIGN));
      dispatch(
        startTrackHomeFeatureUsage({ featureID: HOME_FEATURE_ID.CAMPAIGNS })
      );
    } else {
      setShowErrorGenerating(true);

      if (!isViewOnboarding) {
        dispatch(
          updateNotification(campaignID, {
            status: ALERTS_ASYNC_STATUS.ERROR,
            message: t(CAMPAIGN_GENERATED_ERROR),
            isCreating: false,
            isGenerating: false,
          })
        );
      }

      if (response.code === CAMPAIGN_IS_GENERATING) {
        navigate(ROUTE_CAMPAIGNS, {
          replace: true,
        });
      }
    }
    setPlatformGenerating(null);
  };

  const onSetDataCampaign = (data, changeSection = true) => {
    reset(data);
    if (changeSection) {
      onChangeSectionSelected({
        platform: platformParam || data?.platforms?.[0],
        assetsGroupID: assetsGroupIDParam || undefined,
        adGroupID: adGroupIDParam || undefined,
        adID: adIDParam || undefined,
      });
    }
  };

  const onUpdateAdsCampaignInformationFromPlatforms = async (
    campaignID,
    data
  ) => {
    setIsSyncingData(true);
    setIsLoading(false);
    await onLoadChatMessages(chatIDParam, campaignID);
    const response = await dispatch(
      startUpdateAdsCampaignsInformationFromPlatforms({
        campaignID,
      })
    );
    if (response.ok) {
      const updatedData = response?.data?.campaign;
      const currentURLCampaign = new URLSearchParams(
        window.location.search
      ).get("campaignID");
      const isStale = campaignID !== currentURLCampaign;
      if (isStale) {
        setIsSyncingData(false);
        return;
      }
      onSetDataCampaign(updatedData, true);
      onUpdateCurrencyTaxPlatforms(updatedData?.platformsData);
    } else {
      const currentURLCampaign = new URLSearchParams(
        window.location.search
      ).get("campaignID");
      const isStale = campaignID !== currentURLCampaign;
      if (isStale) {
        setIsSyncingData(false);
        return;
      }
      onSetDataCampaign(data, false);
      const currentData = getValues();
      onUpdateCurrencyTaxPlatforms(currentData?.platformsData);
    }

    setIsSyncingData(false);
    reset(getValues());

    return response;
  };

  const onListenerAdsCampaignActionStatus = async (campaignID) => {
    if (adsCampaignActionStatusListener) {
      await dispatch(
        stopListenerAdsCampaignActionStatus(adsCampaignActionStatusListener)
      );
    }
    dispatch(
      startListenerAdsCampaignActionStatus({
        campaignID,
        onReferenceAvailable: (listener) =>
          setAdsCampaignActionStatusListener(listener),
        onUpdatedDataCallback: (status) => {
          setCampaignActionStatus(status);
        },
      })
    );
  };

  const onVerifyHasCampaignToCreate = async () => {
    const isBlocked = await dispatch(
      getIsBlockedActions({
        action: ADS_CAMPAIGN_GENERATE_CAMPAIGN_ACTION,
        showUsageConfirmationAlert: false,
      })
    );
    if (isBlocked) {
      navigate(ROUTE_CAMPAIGNS);
    }
    return isBlocked;
  };

  const shouldShowNpsForActiveCampaign = (campaignData) => {
    if (!campaignData?.firstActiveTime || !campaignData?.states?.general) {
      return null;
    }

    const isActive = campaignData.states.general === ADS_CAMPAIGN_STATUS_ACTIVE;
    if (!isActive) {
      return null;
    }

    const firstActiveTime = campaignData.firstActiveTime;
    const now = new Date().getTime();
    const daysSinceFirstActive = Math.floor(
      (now - firstActiveTime) / (1000 * 60 * 60 * 24)
    );

    if (daysSinceFirstActive >= 30) {
      return NPS_RATING_ACTION_ACTIVE_30_DAYS;
    } else if (daysSinceFirstActive >= 7) {
      return NPS_RATING_ACTION_ACTIVE_7_DAYS;
    }

    return null;
  };

  const maybeShowImportedCampaignInfoAlert = (campaignID, isImported) => {
    if (!isImported || consumeJustImportedCampaign(campaignID)) {
      return;
    }

    SimpleAlert({
      text: t(ALERT_IMPORTED_CAMPAIGN_READONLY_DESCRIPTION),
      icon: ALERT_ICON_TYPE_INFO,
    });
  };

  const onGetInitialData = async (campaignID) => {
    setIsLoading(true);
    onListenerAdsCampaignActionStatus(campaignID);
    const response = await dispatch(startGetAdsCampaign(campaignID));
    if (response) {
      getBrandInformation(false);

      const data = response;

      const npsActionType = shouldShowNpsForActiveCampaign(data);
      if (npsActionType) {
        dispatch(checkAndShowNpsForm(npsActionType));
      }

      if (data?.generatedPlatforms) {
        setValue("generatedPlatforms", data.generatedPlatforms);
      }

      maybeShowImportedCampaignInfoAlert(campaignID, data?.isImported);

      const hasSomePlatformCreated = Object.keys(response.states || {}).some(
        (key) => response.states[key] !== ADS_CAMPAIGN_STATUS_DRAFT
      );
      if (hasSomePlatformCreated && doSync) {
        onUpdateAdsCampaignInformationFromPlatforms(campaignID, data);
        onSetDataCampaign(data);
      } else {
        if (showDraft) {
          const responseDraft = await dispatch(
            startGetDraftCampaign({ campaignID })
          );
          if (responseDraft.ok) {
            const dataDraft = responseDraft.data;
            onSetDataCampaign(dataDraft);
            setIsLoading(false);
            onUpdateCurrencyTaxPlatforms(dataDraft?.platformsData);
          } else {
            onSetDataCampaign(data);
            setIsLoading(false);
            onUpdateCurrencyTaxPlatforms(data?.platformsData);
          }
        } else {
          onSetDataCampaign(data);
          setIsLoading(false);
          onUpdateCurrencyTaxPlatforms(data?.platformsData);
        }

        // Load chat before showing SlideChat so the opening auto-prompt does not race ahead.
        if (chatIDParam && campaignIDParam) {
          await onLoadChatMessages(chatIDParam, campaignIDParam);
        }
      }
    } else {
      setIsLoading(false);
      getBrandInformation();
      onVerifyHasCampaignToCreate();
    }

    if (params.has("doSync") || params.has("showDraft")) {
      const nextParams = new URLSearchParams(params);
      nextParams.delete("doSync");
      nextParams.delete("showDraft");
      setSearchParams(nextParams);
    }
  };

  const getBrandInformation = async (isNewCampaign = true) => {
    const response = await dispatch(startGetBrandInformation());
    const hasBrandContext = Boolean(
      response?.data?.businessName && response?.data?.businessDescription
    );

    if (!hasBrandContext && isNewCampaign) {
      ConfirmAlert({
        title: t(ALERT_FILL_BRAND_SETUP_TITLE),
        text: t(ALERT_FILL_BRAND_SETUP_DESCRIPTION_FOR_CAMPAIGN),
        confirmButtonText: t(BUTTON_COMPLETE_INFORMATION),
        showCancelButton: false,
      });
      navigate("/settings");
      return;
    }
    if (response.ok) {
      const { data } = response;
      setBrandInformation(data);
    }
  };

  const onChangeStatusCampaign = async ({
    newStatus,
    target = "campaign",
    platform,
    assetsGroupID,
    adGroupID,
    adID,
    showAlertSave = false,
  }) => {
    const currentCampaign = _.cloneDeep(getValues());

    const objectUpdate = getCampaignUpdatedByStatus({
      campaign: getValues(),
      status: newStatus,
      target,
      platform,
      adGroupID,
      adID,
      assetsGroupID,
    });

    reset(objectUpdate);

    let entityID = "";

    if (target === ADS_CAMPAIGN_ENTITIES.PLATFORM) {
      entityID = campaignID;
      const platforms = Object.keys(currentCampaign?.platformIDs || {});
      if (platforms.length === 1) {
        target = ADS_CAMPAIGN_ENTITIES.ALL_CAMPAIGNS;
      }
    }
    if (target === ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP) {
      const id = getValues(`assetsGroups.[${assetsGroupID}].id`);
      entityID = id;
    }
    if (target === ADS_CAMPAIGN_ENTITIES.AD_GROUP) {
      const id = getValues(`adsGroups.[${adGroupID}].id`);
      entityID = id;
    }
    if (target === ADS_CAMPAIGN_ENTITIES.AD) {
      const id = getValues(`adsGroups.[${adGroupID}].ads.[${adID}].id`);
      entityID = id;
    }

    setIsUpdating(true);
    const response = await dispatch(
      startUpdateCampaignEntityStatus({
        campaignID,
        platform,
        entity: target,
        entityID,
        status: newStatus,
      })
    );
    setIsUpdating(false);

    if (!response.ok) {
      reset(currentCampaign);
      return false;
    }

    if (showAlertSave) {
      SimpleAlert({
        title: t(ADS_CAMPAIGN_HAS_BEEN_SAVE),
        icon: ALERT_ICON_TYPE_SUCCESS,
      });
    }

    return true;
  };

  const onChangeSectionSelected = (section) => {
    const {
      from,
      customParams,
      creativeOptimization: creativeOptimizationPayload,
      ...rest
    } = section;
    if (isForcedSetupPage && from !== "addPlatforms") {
      setIsForcedSetupPage(false);
    }

    const restCopy = { ...rest };

    const platforms = getValues("platforms") || [];
    const platformIsPresent = platforms.includes(rest.platform);
    const assetsGroups = getValues("assetsGroups");
    const assetsGroupIsPresent =
      platformIsPresent && rest?.assetsGroupID
        ? assetsGroups?.some(
            (assetsGroup) => assetsGroup?.id === rest?.assetsGroupID
          )
        : false;
    const adsGroups = getValues("adsGroups");
    const adGroupIsPresent =
      platformIsPresent && rest?.adGroupID
        ? adsGroups?.some((adGroup) => adGroup?.id === rest?.adGroupID)
        : false;
    const adIsPresent =
      platformIsPresent && rest?.adGroupID && rest?.adID
        ? adsGroups
            .find((adGroup) => adGroup?.id === rest?.adGroupID)
            ?.ads.find((ad) => ad?.id === rest?.adID)
        : false;

    if (platformIsPresent) {
      params.set("platform", rest.platform);
    } else {
      params.set("platform", platforms[0]);
      restCopy.platform = platforms[0];
    }

    if (assetsGroupIsPresent) {
      params.set("assetsGroupID", rest.assetsGroupID);
    } else {
      params.delete("assetsGroupID");
      restCopy.assetsGroupID = undefined;
    }

    if (adGroupIsPresent) {
      params.set("adGroupID", rest.adGroupID);
    } else {
      params.delete("adGroupID");
      restCopy.adGroupID = undefined;
    }

    if (adIsPresent) {
      params.set("adID", rest.adID);
    } else {
      params.delete("adID");
      restCopy.adID = undefined;
    }

    if (
      creativeOptimizationPayload?.title &&
      creativeOptimizationPayload?.action &&
      creativeOptimizationPayload?.field &&
      creativeOptimizationPayload?.formPath
    ) {
      onUpsertCreativeOptimization(creativeOptimizationPayload);
    }

    const titleFromUrl = params.get("title");
    const actionFromUrl = params.get("action");
    const fieldFromUrl = params.get("field");
    if (titleFromUrl && actionFromUrl && fieldFromUrl) {
      const formPathFromUrl = getFormPathForCreativeSlot({
        getValues,
        adGroupID: restCopy.adGroupID,
        adID: restCopy.adID,
        assetsGroupID: restCopy.assetsGroupID,
      });
      if (formPathFromUrl) {
        onUpsertCreativeOptimization({
          title: titleFromUrl,
          action: actionFromUrl,
          field: fieldFromUrl,
          formPath: formPathFromUrl,
        });
      }
    }

    if (customParams) {
      Object.keys(customParams || {}).forEach((key) => {
        if (_.isUndefined(customParams[key])) {
          params.delete(key);
          return;
        }
        params.set(key, customParams[key]);
      });
    }
    setSearchParams(params);
    setSectionSelected(restCopy);
  };

  const onLoadChatMessages = async (chatID, campaignIDToUse = campaignID) => {
    try {
      const response = await dispatch(
        startGetCampaignChat({
          chatID,
          campaignID: campaignIDToUse,
        })
      );

      if (response.ok && response.data?.messages) {
        const messages = response.data.messages;
        if (Object.keys(messages).length > 0) {
          setChatMessages(messages);
          setShouldOpenChat(true);
        }
      }

      params.delete("chatID");
      setSearchParams(params);
    } catch (error) {
      console.error("Error loading chat messages:", error);
    }
  };

  const onUpdateCurrencyTaxPlatforms = async (platformsData) => {
    const platformsWithData = Object.keys(platformsData || {});
    const currenciesData = {};

    for (const platform of platformsWithData) {
      if (!ADS_CAMPAIGN_PLATFORMS_WITH_MIN_BUDGET_IN_USD.includes(platform)) {
        continue;
      }
      const platformData = platformsData?.[platform];
      if (!platformData) continue;

      const currency = dispatch(
        getCurrencyAdAccountPlatform({
          platform,
          integrationID: platformData?.integrationID,
          adAccountID: platformData?.adAccountID,
        })
      );

      if (!currency) {
        continue;
      }

      if (currenciesData[currency] || currencyTaxes?.[currency] != null) {
        continue;
      }

      const response = await dispatch(startGetCurrencyTax(currency));
      if (response.ok) {
        currenciesData[currency] = response.data;
      }
    }

    setCurrencyTaxes((prev) => ({
      ...(prev || {}),
      ...currenciesData,
    }));
  };

  const onGetItemSelectedLevel = ({
    platform,
    assetsGroupID,
    adGroupID,
    adID,
  }) => {
    if (!platform) return null;
    if (typeof assetsGroupID === "string") {
      return ADS_CAMPAIGN_ENTITIES.ASSETS_GROUP;
    }
    if (typeof adGroupID === "string") {
      return typeof adID === "string"
        ? ADS_CAMPAIGN_ENTITIES.AD
        : ADS_CAMPAIGN_ENTITIES.AD_GROUP;
    }
    return ADS_CAMPAIGN_ENTITIES.PLATFORM;
  };

  const getIsCampaignPlatformActive = (platform) => {
    const state = states?.[platform];
    return (
      state === ADS_CAMPAIGN_STATUS_ACTIVE ||
      state === ADS_CAMPAIGN_STATUS_FINISHED
    );
  };
  const getIsCampaignPlatformCreated = (platform) => {
    const state = states?.[platform];
    return state !== ADS_CAMPAIGN_STATUS_DRAFT;
  };
  const getShowActionsPlatform = (platform) => {
    const isCampaignPlatformCreated = getIsCampaignPlatformCreated(platform);
    const state = states?.[platform];

    return (
      isCampaignPlatformCreated &&
      state &&
      state !== ADS_CAMPAIGN_STATUS_DRAFT &&
      state !== ADS_CAMPAIGN_STATUS_FINISHED
    );
  };
  const getIsGeneralCampaignIncompatible = () => {
    let allCampaignsIncompatible = true;

    platforms.forEach((platform) => {
      const isIncompatible = getValues(
        `platformsData.${platform}.isIncompatible`
      );
      if (!isIncompatible) {
        allCampaignsIncompatible = false;
      }
    });

    return allCampaignsIncompatible;
  };

  const getIsPlatformOptionDisabled = (platformKey) =>
    Boolean(generatedPlatforms?.[platformKey]);

  useEffect(() => {
    reset({
      context: "",
      language: "",
      locations: {
        contexts: [],
        locations: [],
      },
      platforms: [],
    });
    setCreativeOptimizations({});
    setStatistics({});
    setIsLoadingStatistics(false);
    if (campaignIDParam) {
      if (lastInitialLoadCampaignIDRef.current === campaignIDParam) {
        return;
      }
      lastInitialLoadCampaignIDRef.current = campaignIDParam;
      setCampaignID(campaignIDParam);
      onGetInitialData(campaignIDParam);
      return;
    }

    lastInitialLoadCampaignIDRef.current = null;
    getBrandInformation();
    const newCampaignID = dispatch(getKeyDatabase());
    setCampaignID(newCampaignID);

    // Preserve additional parameters like initialCreatives if they exist
    const currentParams = new URLSearchParams(window.location.search);
    const initialCreatives = currentParams.get("initialCreatives");

    let navigationUrl = `/ads-campaign?campaignID=${newCampaignID}`;
    if (initialCreatives) {
      navigationUrl += `&initialCreatives=${encodeURIComponent(initialCreatives)}`;
    }

    navigate(navigationUrl, {
      replace: true,
    });
    setIsLoading(false);

    // eslint-disable-next-line
  }, [campaignIDParam]);

  useEffect(() => {
    if (!isSyncingData) {
      setIsPlatformClicked(false);
    }
  }, [isSyncingData]);

  useEffect(() => {
    function handleInitialized() {
      setSchema(
        getCampaignSchema({ ...brandInformation, integrations, currencyTaxes })
      );
    }

    if (i18next.isInitialized) {
      setSchema(
        getCampaignSchema({ ...brandInformation, integrations, currencyTaxes })
      );
    } else {
      i18next.on("initialized", handleInitialized);
    }

    return () => {
      i18next.off("initialized", handleInitialized);
    };
  }, [brandInformation, integrations, currencyTaxes]);

  useEffect(() => {
    const platformsData = getValues("platformsData");
    if (_.isEmpty(platformsData)) return;
    onUpdateCurrencyTaxPlatforms(platformsData);

    // eslint-disable-next-line
  }, [platformsDepKey]);

  useEffect(() => {
    return () => {
      if (adsCampaignActionStatusListener) {
        dispatch(
          stopListenerAdsCampaignActionStatus(adsCampaignActionStatusListener)
        );
      }
    };
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!campaignID) return;

    onChangeSectionSelected({
      platform: platformParam || undefined,
      assetsGroupID: assetsGroupIDParam || undefined,
      adGroupID: adGroupIDParam || undefined,
      adID: adIDParam || undefined,
    });
    // eslint-disable-next-line
  }, [platformParam, assetsGroupIDParam, adGroupIDParam, adIDParam]);

  useEffect(() => {
    if (!campaignID) return;

    const items = pendingIntegrationFormSync?.items || [];
    if (!Array.isArray(items) || items.length === 0) return;

    const matching = items.filter((item) => item.campaignID === campaignID);
    if (matching.length === 0) return;

    matching.forEach(({ platform, integrationID }) => {
      if (platform == null || platform === "") return;
      if (integrationID == null || integrationID === "") return;
      setValue(`platformsData.${platform}.integrationID`, integrationID);
    });
    onChangeSectionSelected(sectionSelected);
    dispatch(consumePendingIntegrationFormSyncForCampaign(campaignID));

    // eslint-disable-next-line
  }, [campaignID, pendingIntegrationFormSync, setValue]);

  const onListenerCampaignApproval = async (nextCampaignID) => {
    if (campaignApprovalListener) {
      await dispatch(stopListenerCampaignApproval(campaignApprovalListener));
    }

    if (!nextCampaignID) {
      setCampaignApproval(normalizeCampaignApprovalState(null));
      setCampaignApprovalListener(null);
      return;
    }

    dispatch(
      startListenerCampaignApproval({
        campaignID: nextCampaignID,
        onReferenceAvailable: (listener) =>
          setCampaignApprovalListener(listener),
        onUpdatedDataCallback: (approvalData) => {
          setCampaignApproval(approvalData);
        },
      })
    );
  };

  useEffect(() => {
    onListenerCampaignApproval(campaignID);

    return () => {
      if (campaignApprovalListener) {
        dispatch(stopListenerCampaignApproval(campaignApprovalListener));
      }
    };
    // eslint-disable-next-line
  }, [campaignID]);

  useEffect(() => {
    const previousStatus = previousApprovalStatusRef.current;
    const nextStatus = deriveApprovalStatusFromReviewers({
      reviewers: campaignApproval?.reviewers,
      fallbackStatus: campaignApproval?.status,
    });

    if (previousStatus !== "rejected" && nextStatus === "rejected") {
      setIsApprovalCommentsPanelOpen(false);
    }

    previousApprovalStatusRef.current = nextStatus;
  }, [campaignApproval?.status, campaignApproval?.reviewers]);

  // Establecer visibilidad del chat basado en el tamaño de pantalla
  useEffect(() => {
    setIsChatVisible(isLargeScreen);
  }, [isLargeScreen]);

  // Funciones para controlar la visibilidad del chat
  const handleOpenChat = () => {
    setIsChatVisible(true);
  };

  const onCloseChat = () => {
    setIsChatVisible(false);
  };

  const onResetChat = () => {
    setValue("report", {});
  };

  const handleToggleChat = () => {
    setIsChatVisible(!isChatVisible);
  };

  const levelSectionSelected = onGetItemSelectedLevel({
    platform: sectionSelected.platform,
    assetsGroupID: sectionSelected.assetsGroupID,
    adGroupID: sectionSelected.adGroupID,
    adID: sectionSelected.adID,
  });

  const isGeneralCampaignIncompatible = getIsGeneralCampaignIncompatible();
  const isGeneralCampaignActivated = getIsCampaignPlatformActive("general");
  const isGeneralCampaignCreated = getIsCampaignPlatformCreated("general");
  const canEditCampaign = dispatch(getRoleCapability("canEditCampaign"));
  const isGeneralDisabledFields =
    !canEditCampaign || isGeneralCampaignIncompatible || isSyncingData;

  const isAllCampaignsPlatformCreated =
    platforms.length > 0 &&
    !platforms?.some((platform) => !platformIDs?.[platform]);

  if (isLoading) {
    return (
      <Loader fullWidth hasMessage={true} message={t(LOADING_INFORMATION)} />
    );
  }
  return (
    <Box
      onClick={() => setIsPlatformClicked(true)}
      sx={{
        display: "flex",
        flexDirection: { xs: "column", md: "row" },
        height: { xs: "auto", md: `calc(100vh - ${totalTopOffsetPx}px)` },
        minHeight: { xs: "100vh", md: "auto" },
        overflowX: { xs: "hidden", md: "visible" },
        overflowY: { xs: "auto", md: "initial" },
      }}
    >
      <Helmet>
        <title>{`${theme.nameBusiness} - Campaign`}</title>
      </Helmet>
      <FormProvider
        {...methods}
        campaignID={campaignID}
        onGenerateCampaignPlatform={onGenerateCampaignPlatform}
        platformGenerating={platformGenerating}
        isGenerating={Boolean(platformGenerating)}
        isSyncingData={isSyncingData}
        sectionSelected={sectionSelected}
        onChangeSectionSelected={onChangeSectionSelected}
        levelSectionSelected={levelSectionSelected}
        onGetItemSelectedLevel={onGetItemSelectedLevel}
        isGeneralCampaignActivated={isGeneralCampaignActivated}
        isGeneralCampaignCreated={isGeneralCampaignCreated}
        isGeneralDisabledFields={isGeneralDisabledFields}
        isGeneralCampaignIncompatible={isGeneralCampaignIncompatible}
        getIsCampaignPlatformCreated={getIsCampaignPlatformCreated}
        getIsCampaignPlatformActive={getIsCampaignPlatformActive}
        hasSomePlatformDraft={hasSomePlatformDraft}
        hasSomePlatformCreated={hasSomePlatformCreated}
        onChangeDataModalErrorsCampaigns={setDataModalErrorsCampaigns}
        onChangeModalErrorsCampaignsOpen={setModalErrorsCampaignsOpen}
        onChangeStatusCampaign={onChangeStatusCampaign}
        getShowActionsPlatform={getShowActionsPlatform}
        showErrorGenerating={showErrorGenerating}
        lastInformationToGenerate={lastInformationToGenerate}
        isUpdating={isUpdating}
        onChangeIsUpdating={setIsUpdating}
        isAllCampaignsPlatformCreated={isAllCampaignsPlatformCreated}
        isForcedSetupPage={isForcedSetupPage}
        onChangeIsForcedSetupPage={setIsForcedSetupPage}
        brandInformation={brandInformation}
        statistics={statistics}
        previewsCached={previewsCached}
        onChangePreviewsCached={setPreviewsCached}
        audiencePreviewsCache={audiencePreviewsCache}
        onChangeAudiencePreviewsCache={setAudiencePreviewsCache}
        onChangeStatistics={setStatistics}
        isLoadingStatistics={isLoadingStatistics}
        onChangeIsLoadingStatistics={setIsLoadingStatistics}
        currencyTaxes={currencyTaxes}
        setCurrencyTaxes={setCurrencyTaxes}
        dateFiltersForm={methodsDateFilters}
        campaignActionStatus={campaignActionStatus}
        campaignApproval={campaignApproval}
        isEnablingCampaignApproval={isEnablingCampaignApproval}
        onEnableCampaignApproval={onEnableCampaignApproval}
        onCopyCampaignApprovalLink={onCopyCampaignApprovalLink}
        onOpenCampaignApprovalCommentsPanel={
          onOpenCampaignApprovalCommentsPanel
        }
        onSaveAdsCampaignDraftWithApproval={(payload) =>
          dispatch(startSaveAdsCampaignWithApproval(payload))
        }
        optimizations={optimizations}
        onChangeOptimizations={setOptimizations}
        chatMessages={chatMessages}
        onChangeChatMessages={setChatMessages}
        shouldOpenChat={shouldOpenChat}
        onChangeShouldOpenChat={setShouldOpenChat}
        isChatVisible={isChatVisible}
        onChangeIsChatVisible={setIsChatVisible}
        onOpenChat={handleOpenChat}
        onCloseChat={onCloseChat}
        onToggleChat={handleToggleChat}
        isViewOnboarding={isViewOnboarding}
        getIsPlatformOptionDisabled={getIsPlatformOptionDisabled}
        clearPreloadedChatMessagesRef={clearPreloadedChatMessagesRef}
        creativeOptimizations={creativeOptimizations}
        onUpsertCreativeOptimization={onUpsertCreativeOptimization}
        onRemoveCreativeOptimization={onRemoveCreativeOptimization}
        isPlatformClicked={isPlatformClicked}
      >
        <ApprovalCommentFieldHintProvider>
          {isMobile && isViewOnboarding && platforms.length === 0 && (
            <SlideMenu hideMobileFooter={false} />
          )}
          {!isViewOnboarding && platforms.length > 0 && <Sidebar />}
          <GeneralContainer />
          {!isViewOnboarding &&
          campaignApproval?.enabled &&
          isApprovalCommentsPanelOpen ? (
            <CampaignApprovalPanel
              approvalData={campaignApproval}
              onChangeSectionSelected={onChangeSectionSelected}
            />
          ) : null}

          {!isViewOnboarding && (
            <SlideChat
              isVisible={isChatVisible}
              onCloseChat={onCloseChat}
              onResetChat={onResetChat}
              onRegisterClearPreloadedMessages={(fn) =>
                (clearPreloadedChatMessagesRef.current = fn)
              }
            />
          )}
          <FloatingValidationErrorsPanel />
          <ApprovalEnableSuccessDialog
            modalOpen={approvalSuccessDialog.open}
            onCloseModal={() =>
              setApprovalSuccessDialog((prev) => ({ ...prev, open: false }))
            }
            approvalType="campaign"
            approvalUrl={approvalSuccessDialog.approvalUrl}
            approvalID={campaignID}
            reviewerID={approvalSuccessDialog.reviewerID}
          />
          {modalErrorsCampaignsOpen && (
            <ModalErrorsCampaigns
              modalOpen={modalErrorsCampaignsOpen}
              onCloseModal={() => setModalErrorsCampaignsOpen(false)}
              campaign={getValues()}
              successCampaigns={dataModalErrorsCampaigns.successCampaigns}
              failedCampaigns={dataModalErrorsCampaigns.failedCampaigns}
              errors={dataModalErrorsCampaigns.errors}
            />
          )}
        </ApprovalCommentFieldHintProvider>
      </FormProvider>
    </Box>
  );
};

export default NewAdsCampaign;
